import { Heading, type HeadingProps } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

export function SlideHeading({ level = 2, className, ...rest }: HeadingProps) {
  return (
    <Heading level={level} className={cn('text-[22px] text-foreground', className)} {...rest} />
  );
}
